import { render, staticRenderFns } from "./sbInsertionDialog.vue?vue&type=template&id=58927128&scoped=true"
import script from "./sbInsertionDialog.vue?vue&type=script&lang=ts"
export * from "./sbInsertionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58927128",
  null
  
)

export default component.exports